import { render, staticRenderFns } from "./downloadNew.vue?vue&type=template&id=6408313f&scoped=true"
import script from "./downloadNew.vue?vue&type=script&lang=ts"
export * from "./downloadNew.vue?vue&type=script&lang=ts"
import style0 from "./downloadNew.vue?vue&type=style&index=0&id=6408313f&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6408313f",
  null
  
)

export default component.exports